<template>
		<div class="study">
			<van-nav-bar fixed left-arrow @click-left="clickNavBack" :border="false" z-index="11"/>
			<div class="player"/>
			<div class="main" style="position:relative;">
				<studyTitle
				:info="playVideo"
				:loadingFace="loadingFace"
				@handleFace="handleFace"
				@imgChange="imgChange"
				/>
				<div class="content">
				<studySidebar
					:list="videoTree"
					:cur="playVideoChapter"
					:act="orderChapterLocal"
					:actVideo="playVideo"
					@clickToggleChapter="clickToggleChapter"
				/>
				<studyList
					:chapter="playVideoChapter"
					:current="playVideo"
					:mustVideo="orderVideoLocal"
					:isPlayState="isPlayState"
					:videoList="videoList"
					@clickVideo="clickVideo"
				/>
			</div>
			</div>
			<!-- <div class="sign-wrap" v-if="showPopover">
				<div>
					<img src="../../assets/v-tips.png" alt="">
				</div>
				<div class="sign-text">
					<div v-for="(item,index) in issign" :key="index" class="text-box" @click="signtip(index)">
						<div class="text-btns" :class="iscolor==index?'btn-color':''"></div>
						<span class="text-text">{{ item.text }}</span>
					</div>
				</div>
			</div> -->
			<input v-show="false" ref="imgChange" @change="imgChange($event)" type="file" accept="image/*" capture="user">
		</div>
</template>

<script>
import 'xgplayer/dist/index.min.css'
import HlsJsPlugin from 'xgplayer-hls.js'
import Player,{ Events } from 'xgplayer'
import studyTitle from './components/title'
import studySidebar from './components/sidebar'
import {viewLogPush,lastWatchLength,getPlanInfo,getVideoUrl} from "../../api/user"
import {Dialog} from "vant";
import studyList from './components/list'
import store from "../../store";
import Compressor from 'compressorjs';
import {getUserId} from "@/utils/cookie";
// 需要独立引用是css文件

export default {
	name: 'study1',
	data: () => ({
		loadingFace:false,
		videoTree: [], // 视频数据结构树
		videoList: [], // 所有可播放视频节点的数组集合
		orderChapterLocal: {}, 	// 顺序播放视频的章节实际位置
		orderVideoLocal: {}, 	// 顺序播放视频实际位置
		playVideo: {}, // 正在播放的视频
		playVideoChapter: [], // 当前播放视频所属的章节
		isPlayState: false, // 当前是否正在播放
		showPopover: true,
		middleFace: false,
		faceRecognitionType: null,
		player: null,
		submitStudyTimer: null, 	// 定时器
		playModeType: '0', 			// 学习计划-连续播放状态
		provinceCode: null,			// 学习计划-省份代码
		categoryId: null,			// 学习计划-类别体系id
		pendingSeekTime: 0,			// 待恢复时间点（自动播放失败时用）
		needSeekToLast: true,		// 是否需要跳转到上次记录（true=首次进入/签到，false=切下一集）
		_gestureBound: false,		// 防止重复绑定用户手势监听
	}),
	issign: [{
				text: '我已知晓'
			}, {
				text: '别再提示'
			}
		],
	components: {studySidebar,studyList,studyTitle},
	computed: {
		userid() {
			return typeof (this.$store.state.user.userid) === 'undefined' ? getUserId() : this.$store.state.user.userid
		},
		isUseJSPlayPhoto() {
			if (this.$store.state.cache.screen.wx) return true
			if (this.$route.query.state === 'js') return false
			// if (sessionStorage.getItem('anhuihefei') === '1') {
			//	return false
			// }
			if (this.$store.state.cache.single && this.$store.state.cache.single.state === 'single') return true
			return true
		},
		appno() {
			return this.$store.state.app.appno
		}
	},
	created() {
		this.getPlanInfo()
		/** 清除签到人脸 **/
		this.$store.commit('cache/set_face', {key: 'signInPhoto', value: ''})
		/** 加载视频列表 **/
		this.loadVideoList()
		if (localStorage.getItem('showPopover')) {
			this.showPopover = JSON.parse(localStorage.getItem('showPopover'))
		} else {
			this.showPopover = true;
		}
	},
	mounted() {
		const _this = this
		/** 绑定拍照 JS 回调事件 **/
		window['receivePhotoResult'] = (base64) => {
			this.receivePhotoResult(base64);
		}
		window.getCameraData = (base64) => {
			console.log('uni-app.study 拍照回调', base64.substring(0, 10))
			this.receivePhotoResult(base64);
		}
		if (this.$store.state.cache.screen.wx) {
			this.uploading = true
			this.$api.wxConfig().then(res => {
				if (res.code === 0) {
					const data = res.data
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: data.appId, // 必填，公众号的唯一标识
						timestamp: data.timestamp, // 必填，生成签名的时间戳
						nonceStr: data.nonceStr, // 必填，生成签名的随机串
						signature: data.signature,// 必填，签名
						jsApiList: ['chooseImage', 'uploadImage'] // 必填，需要使用的JS接口列表
					})
				}
			})
			wx.ready(() => {
				_this.uploading = false
			})
			wx.error(err => {
				_this.uploading = false
				console.log('微信config出错 ===', err)
				this.$utils.dialog.alert(`微信config失败：${err.errMsg}`)
			})
		}
	},
	destroyed() {
		// 关键修复：离开页面停止所有定时器，防止 viewLogPush 持续调用
		this.timingSubmitStudyThrittle('clear')
		if (this.submitStudyTimer) {
			clearTimeout(this.submitStudyTimer)
			this.submitStudyTimer = null
		}
		if (this.timer) {
			clearTimeout(this.timer)
			this.timer = null
		}
		// 销毁播放器
		if (this.player && this.player.destroy) {
			this.player.destroy()
			this.player = null
		}
		console.log('[study1-index] destroyed 清理定时器')
	},
	methods:{
		// 获取学习计划
		getPlanInfo() {
			//const _this = this
			getPlanInfo(this.userid).then(res => {
				this.playModeType = res.playModeType;
				this.categoryId = res.categoryId;
				this.provinceCode = res.provinceCode;
				this.faceRecognitionType = res.faceRecognitionType;
				// 常州教练员允许倍速
				// if (',119,'.indexOf(',' + _this.categoryId + ',') !== -1 && _this.provinceCode === '320000') {
				// 	this.showRateBtn = 1;
				// }
			})
		},
		/** 点击切换播放的视频 **/
		clickVideo(video) {
			this.orderVideoLocal = this.videoList[this.orderVideoLocalIndex]
			if (video.watchedFlag === '0' && video.basePkId !== this.orderVideoLocal.basePkId) {
				this.$utils.dialog.alert('请按顺序进行学习')
			} else {
				this.playVideo = video
				if (this.playModeType === '1') {
					this.loadVideo(video)
				} else {
					this.loadVideo(video)
				}
			}
		},
		/** 加载下一个播放的视频节点 **/
		loadNextVideo() {
			// orderChapterLocal
			const curIndex = this.videoList.findIndex(item => item.basePkId === this.orderVideoLocal.basePkId)
			this.orderVideoLocal.watchedFlag = '1'
			if (curIndex < (this.videoList.length - 1)) {
				this.orderVideoLocal = this.videoList[curIndex + 1]
				this.playVideo = this.videoList[curIndex + 1]
				for (let i = 0, len = this.videoTree.length; i < len; i++) {
					const chapterIndex = this.videoTree[i].children.findIndex(item => item.basePkId === this.playVideo.parentPkId)
					if (chapterIndex > -1) {
						this.videoTree[i].children[chapterIndex].children[this.playVideo.chapterIndex - 1] = this.orderVideoLocal
						if (this.videoList[curIndex + 1].chapterIndex === 1) {
							this.playVideoChapter = this.videoTree[i]
							this.orderChapterLocal = this.videoTree[i]
						}
						break
					}
				}
				// 关键修复：切下一集时不查询 lastWatchLength（下一个视频应该未观看，从 0 开始）
				this.needSeekToLast = false
				this.switchToNextVideo(this.videoList[curIndex + 1])
				// 调用后恢复默认值（下次签到进入时仍需要跳转）
				this.needSeekToLast = true
			}
		},
		/** 加载视频列表 **/
		loadVideoList() {
			this.$api.getVideoList({
				subject: this.$route.query.subject,
				studentId: this.userid,
				courseId: this.$route.query.courseid,
			}).then(res => {
				if (res.code === 0) {
					this.loadVideoListFormat(res.data)
				}
			})
		},
		clickToggleChapter(data) {
			this.playVideoChapter = data
		},
		/** 格式化视频列表 **/
		loadVideoListFormat(data) {
			this.videoTree = []
			for (let i = 0, len = data.length; i < len; i++) {
				if (data[i].type === 3) {
					this.videoList.push(data[i])
				}
				if (data[i].parentPkId === 0) {
					this.videoTree.push(data[i])
				} else {
					this.videoTree = this.loadVideoListFormatRecursive(this.videoTree, data[i])
				}
			}
			if (JSON.stringify(this.playVideo) === '{}') {
				this.playVideo = this.videoList[this.videoList.length - 1]
				this.playVideoChapter = this.videoTree[this.videoTree.length - 1]
				this.loadVideo(this.playVideo)
			}
		},
		loadVideo(data) {
			// 销毁旧 Player 防止内存泄漏
			if (this.player) {
				try { this.player.destroy(true) } catch (e) { console.log('destroy old player fail', e) }
				this.player = null
			}
			// 重置 pendingSeekTime（防止上一个视频的恢复时间干扰下一个视频）
			this.pendingSeekTime = 0
			// 关键修复：不在主流程中调用 lastWatchLength（之前返回了 0 导致不跳转）
			// 改为在 Events.LOADED_METADATA 中调用（参数正确，返回真实的 watchLength）
			if (this.needSeekToLast) {
				// 签到进入/手动点击：先记录需要跳转，由 LOADED_METADATA 触发 lastWatchLength
				console.log('[study1] 加载视频，将通过 LOADED_METADATA 触发 lastWatchLength')
			} else {
				// 切下一集：不需要跳转，直接播放
				console.log('[study1] 切下一集，跳过 lastWatchLength')
			}
			this.createPlayerWithUrl(data)
		},
		/**
		 * 创建 player（已获取上次观看时间）
		 */
		createPlayerWithUrl(data) {
			getVideoUrl(data.video.basePkId,this.userid).then(res => {
			const isSupported = document.createElement('video').canPlayType('application/vnd.apple.mpegurl')
			if (isSupported) {
				// 原生支持 hls 播放
				this.player = new Player({
					el: document.querySelector('.player'),
					ignores: ['cssfullscreen', 'replay', 'pc', 'error'],//禁用播放器自带插件
					playsinline: true,
					fluid: true,
					poster:data.video.videoCover,
					muted: true,// 移动端自动播放策略要求静音
					// 关键修复：移除 autoplay: true，避免覆盖手动设置的 currentTime
					// 由 CANPLAY/SEEKED 事件手动调用 play()
					// autoplay: true,
					volume: 0.6,
					progress: {
						closeMoveSeek:true,//关闭滑块seek能力，进度条无法快进/快退
						isPauseMoving:true,//是否在拖拽的过程是否暂停视频播放
						isCloseClickSeek:true,//进度条点击seek能力
					},
					dynamicbg: {
						disable: true
					},
					mobile: {
						pressRate:1,//长按倍速
						gestureX:false,//禁用水平手势处理，水平手势快进/快退
					},
					fullscreen: {
						useCssFullscreen: true, // 使用网页内全屏替换全屏效果
						position: 'controlsRight' // 按钮移动到控制栏左侧
					},
					definition:{
					list:[{
						definition: '320p',// 清晰度
						url: res.videoItem[1].playurl,
						text: {
							zh: '标清', // 显示中文文案
							en: '320P' // 显示英文文案
						}
						},{
						definition: '480p',// 清晰度
						url: res.videoItem[0].playurl,  // 对应播放地址
						text: {
							zh: '高清',  // 显示中文文案
							en: '480P'   // 显示英文文案
						}
						}]
					},
					playbackRate: [1],//倍速
					'x5-video-player-type': 'h5',
					'x5-video-player-fullscreen': false,
					'x5-video-orientation': 'landscape'
				})
			} else if (HlsJsPlugin.isSupported()) { // 第一步
				console.log("调用插件",HlsJsPlugin.isSupported())
				this.player = new Player({
					el: document.querySelector('.player'),
					isLive: false,
					poster:data.video.videoCover,
					ignores: ['cssfullscreen', 'replay', 'pc', 'error'],//禁用播放器自带插件
					plugins: [HlsJsPlugin], // 第二步
					fluid: true,
					muted: true,// 移动端自动播放策略要求静音
					// 关键修复：移除 autoplay: true，避免覆盖手动设置的 currentTime
					// autoplay: true,
					volume: 0.6,
					progress: {
						closeMoveSeek:true,//关闭滑块seek能力，进度条无法快进/快退
						isPauseMoving:true,//是否在拖拽的过程是否暂停视频播放
						isCloseClickSeek:true,//进度条点击seek能力
					},
					dynamicbg: {
						disable: true
					},
					mobile: {
						pressRate:1,//长按倍速
						gestureX:false,//禁用水平手势处理，水平手势快进/快退
					},
					fullscreen: {
						useCssFullscreen: true, // 使用网页内全屏替换全屏效果
						position: 'controlsRight' // 按钮移动到控制栏左侧
					},
					definition:{
					list:[{
						definition: '320p',// 清晰度
						url: res.videoItem[1].playurl,
						text: {
							zh: '标清', // 显示中文文案
							en: '320P' // 显示英文文案
						}
						},{
						definition: '480p',// 清晰度
						url: res.videoItem[0].playurl,  // 对应播放地址
						text: {
							zh: '高清',  // 显示中文文案
							en: '480P'   // 显示英文文案
						}
						}]
					},
					playbackRate: [1],//倍速
					'x5-video-player-type': 'h5',
					'x5-video-player-fullscreen': false,
					'x5-video-orientation': 'landscape'
				})
			}
			// [study1] 调试日志
			this.player.on(Events.LOADED_METADATA, () => console.log('[study1] LOADED_METADATA', this.playVideo.videoId))
			this.player.on(Events.CANPLAY, () => console.log('[study1] CANPLAY', this.playVideo.videoId))
			this.player.on(Events.PLAY, () => console.log('[study1] PLAY'))
			this.player.on(Events.PLAYING, () => console.log('[study1] PLAYING'))
			this.player.on(Events.AUTOPLAY_PREVENTED, () => console.log('[study1] AUTOPLAY_PREVENTED'))

			// 关键修复：使用 LOADED_METADATA 触发 lastWatchLength（替代主流程）
			// 原因：主流程中调用返回 watchLength=0，但 LOADED_METADATA 中调用返回正确的 120
			// 这表明主流程的参数或时序有问题，LOADED_METADATA 中调用更可靠
			// 注意：切下一集时（needSeekToLast=false）不调用 lastWatchLength
			this.player.once(Events.LOADED_METADATA, () => {
				console.log('[study1] LOADED_METADATA 触发', this.playVideo.videoId)
				// 切下一集时不查询 lastWatchLength
				if (!this.needSeekToLast) {
					return
				}
				// pendingSeekTime 已有值，跳过
				if (this.pendingSeekTime > 0 && this.player && !this.middleFace) {
					return
				}
				// 签到进入：调用 lastWatchLength
				lastWatchLength({
					studentId: this.userid,
					videoId: this.playVideo.videoId
				}).then(res => {
					const targetTime = res.watchLength || 0
					console.log('[study1] LOADED_METADATA 跳转时间', targetTime)
					if (targetTime > 0 && this.player && !this.middleFace) {
						this.player.currentTime = targetTime
						this.pendingSeekTime = targetTime
						console.log('[study1] 设置后立即 currentTime =', this.player?.currentTime)
						// 关键修复：使用最原始的强制 seek 方法（循环重试直到 currentTime 稳定）
						this.forceSeekTo(targetTime)
					}
				}).catch(e => console.log('[study1] LOADED_METADATA 获取失败', e))
			})

			// PLAYING 作为兜底（首次观看 watchLength=0 时）
			// 注意：跳转场景的播放由 forceSeekTo 内部处理
			this.player.once(Events.PLAYING, () => {
				console.log('[study1] PLAYING 触发')
				// 只在首次观看（pendingSeekTime=0）且仍在暂停状态时触发
				if (this.player && this.player.paused && !this.pendingSeekTime) {
					this.player.play().catch(() => {
						console.log('[study1] PLAYING 后 play 被拦截，等待用户手势')
						this.bindOnceUserGesture()
					})
				}
			})

			// CANPLAY 作为兜底（首次观看 watchLength=0 时）
			this.player.once(Events.CANPLAY, () => {
				if (!this.pendingSeekTime && this.player && this.player.paused) {
					// 首次观看且暂停时，尝试播放
					this.player.play().catch(() => {
						console.log('[study1] CANPLAY 自动播放失败，等待用户手势')
						this.bindOnceUserGesture()
					})
				}
				// 如果 pendingSeekTime > 0，由 forceSeekTo 处理
			})

			// 关键修复：使用 PLAY（而非 PLAYING）作为播放状态触发
			// 原因：PLAY 在 play() 调用后立即触发，PLAYING 仅在实际播放时触发
			this.player.on(Events.PLAY,()=>{
				if (this.middleFace === true) {
					this.timingSubmitStudy();
					return
				}
				this.isPlayState = true
				this.recordStudyTime(0)
				// 开启节流 60S 一次
				this.timingSubmitStudyThrittle(60000)
			})

			this.player.on(Events.PAUSE,()=>{
				this.timingSubmitStudyThrittle('clear')
				this.isPlayState = false
			})

			// PLAYING 仅做实际播放状态的标记和索引同步
			this.player.on(Events.PLAYING, () => {
				this.orderVideoLocalIndex = this.videoList.indexOf(this.orderVideoLocal);
			})

			// 关键修复：监听自动播放被拦截事件（移动端常见）
			this.player.on(Events.AUTOPLAY_PREVENTED, () => {
				console.log('[study1] 自动播放被浏览器拦截，等待用户手势')
				this.bindOnceUserGesture()
			})

			this.player.on(Events.ENDED, () => {
				this.isPlayState = false
				this.timingSubmitStudyThrittle('clear')
				this.recordStudyTime(this.playVideo.video.videoDuration, 'next')
				if (localStorage.getItem('videoPlayNums')) {
					let times = parseInt(localStorage.getItem('videoPlayNums')) + 1;
					localStorage.setItem('videoPlayNums', '' + times + '');
				}
			})
			})
		},
		/**
		 * 切换到下一个视频（不销毁 player）
		 * 关键修复：使用 switchURL 保留 user gesture context，确保自动播放
		 * 同时显式调用 lastWatchLength 获取新视频的上次观看时间
		 */
		switchToNextVideo(video) {
			if (!this.player) {
				// 没有 player 时需要走完整 loadVideo 流程
				this.needSeekToLast = true
				this.loadVideo(video)
				return
			}
			// 更新 playVideo 引用（事件回调中需要）
			this.playVideo = video
			// 重置 pendingSeekTime（新视频的时间）
			this.pendingSeekTime = 0
			// 重置学时相关状态
			this.timingSubmitStudyThrittle('clear')

			getVideoUrl(video.video.basePkId, this.userid).then(res => {
				const url = res.videoItem[0].playurl
				// 使用 switchURL 保留 player 实例（关键：保留 user gesture context）
				if (typeof this.player.switchURL === 'function') {
					this.player.switchURL(url).then(() => {
						console.log('[study1] switchURL 完成，下一集从 0 开始播放')
						// 关键修复：切下一集不查询 lastWatchLength，直接播放
						// 不设置 currentTime，让视频从 0 开始
						this.player.play().catch(() => {
							console.log('[study1] switchURL 后 play 被拦截，等待用户手势')
							this.bindOnceUserGesture()
						})
					}).catch(err => {
						console.log('[study1] switchURL 失败，降级为重建', err)
						// 降级时也需要设置 needSeekToLast = false（切下一集不跳转）
						this.needSeekToLast = false
						this.loadVideo(video)
					})
				} else {
					// switchURL 不存在，降级为 loadVideo（销毁重建）
					console.log('[study1] switchURL API 不存在，使用 loadVideo')
					// 降级时也需要设置 needSeekToLast = false
					this.needSeekToLast = false
					this.loadVideo(video)
				}
			}).catch(err => {
				console.log('[study1] 获取视频URL失败', err)
			})
		},
		/** 记录学时 **/
		recordStudyTime(watchLength, type = '') {
			// 只有当前播放的视频跟要学习的视频是同一个视频的时候，才会记录学时
			if (this.playVideo.basePkId === this.orderVideoLocal.basePkId) {
				this.$api.watchVideo({
					studentId: this.userid,
					signId: this.$route.query.signId,
					videoId: this.playVideo.videoId,
					chapterId: this.playVideo.basePkId,
					courseId: this.$route.query.courseid,
					watchLength: this.player.currentTime || 0 ,
					videoLength: this.playVideo.video.videoDuration
				}).then(res => {
					if (res.code === 0) {
						if (type === 'next') this.loadNextVideo()
					}
				}).catch(() => {
					// API 失败也要切换下一集，不能阻塞视频流程
					if (type === 'next') this.loadNextVideo()
				})
			} else {
				this.orderVideoLocal = {};
				if (type === 'next') this.loadVideoList();
			}
		},
		delayEndTheStudyProc() {
			this.timer = setTimeout(() => {
				this.signBackNoPhoto();
			}, 180000);
		},
		destroyedTimer() {
			if (this.timer !== null) {
				clearTimeout(this.timer);
			}
		},
		/**
		 * @param { number | string } wait： 执行时间 (number) 是否停止定时器 (string: clear)
		 */
		timingSubmitStudyThrittle(wait) {
			const _this = this;
			if (typeof wait === 'string' && wait === 'clear') {
				if (this.submitStudyTimer) {
					clearTimeout(_this.submitStudyTimer)
					this.submitStudyTimer = null
				}
			} else if (typeof wait === 'number') {
				if (!this.submitStudyTimer) {
					this.submitStudyTimer = setTimeout(() => {
						_this.timingSubmitStudy();
						_this.submitStudyTimer = null
						_this.timingSubmitStudyThrittle(wait)
					}, wait)
				}
			}
		},
		// 提交学时，20S一次，暂停时、播放结束时，均需保存学时
		timingSubmitStudy(/*...data */) {
			const _this = this;
			viewLogPush({
				chapterId: this.playVideo.basePkId /* '章节ID' */,
				courseId: this.$route.query.courseId /*'课程ID'*/,
				planId: this.$store.state.user.planid /* '学员计划ID'*/,
				signId: this.$route.query.signId /* '签到ID'*/,
				studentId: this.userid /* '学员ID'*/,
				videoId: this.playVideo.videoId /* '视频ID' */,
				videoLength: this.playVideo.video.videoDuration /* '视频总长度' */,
				watchLength: this.player.currentTime || 0 /* '当前观看长度' */
			}).then(res => {
				if (res.signTime) {
					this.player.pause();
					this.player.exitCssFullscreen();
					_this.middleFace = true;
					this.$utils.dialog.alert('需要进行人脸识别，请端正手机拍照！（不要躺着，手机拿正拍照）', () => {
						// 此处 调用APP 摄像头方法
						if (_this.isUseJSPlayPhoto) {
							_this.handleFace()
						} else {
							_this.$refs.imgChange.click()
						}
					});
					/* 江西初学3分钟内 */
					if ( _this.$store.state.user.planid == 151 ) _this.delayEndTheStudyProc();
				}
			}).catch(() => {
				_this.player.pause();
				clearTimeout(_this.submitStudyTimer)
			})
		},
		/** 拍照区域 **/
		handleFace() {
			const _this = this
			if (this.faceRecognitionType === null) {
				_this.$utils.dialog.alert('手速太快休息一会儿~');
				return;
			}
			if (this.faceRecognitionType === '0') {
				this.signBackNoPhoto();
			}
			if (this.loadingFace) return
			// 关键修复：拍照前先暂停视频，避免人脸识别期间视频继续播放
			if (this.player && !this.middleFace) {
				try { this.player.pause(); } catch (e) { console.log('[study1] pause fail', e) }
			}
			if (this.$store.state.cache.screen.wx) {
				wx.chooseImage({
					count: 1, // 默认9
					sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
					sourceType: ['camera'], // 可以指定来源是相册还是相机，默认二者都有
					success: function (res) {
						wx.uploadImage({
							localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口由 chooseImage 接口获得
							isShowProgressTips: 1, // 默认为1，显示进度提示
							success: function (uploadRes) {
								_this.loadingFace = true
								_this.$api.wxCompareFace({
									mediaId: uploadRes.serverId,
									signId: _this.$route.query.signId,
									chapterId: _this.playVideo.basePkId
								}).then((res) => {
									_this.loadingFace = false
									if (res.code === 0) {
										if (_this.middleFace) { // 如果是中间验证人脸，验证完成之后，还原为false，如果是false，就走签退
											_this.handleFaceSuccess()
										} else {
											_this.signBack({
												mediaId: uploadRes.serverId
											})
										}
									} else {
										// 人脸识别失败，需要用户主动触发再次识别
										_this.handleFaceFail()
									}
								}).catch(() => {
									_this.loadingFace = false
									_this.handleFaceFail()
								})
							}
						})
					}
				})
			} else {
				if (this.$store.state.cache.screen.isAndroid) {
					if (uni) {
						uni.postMessage({
							data: {
								action: 'setCamera'
							}
						});
						//return;
					}
					if (window.Android_JS && window.Android_JS.androidPhoto) {
						window.Android_JS.androidPhoto();
					}
				}
				if (this.$store.state.cache.screen.isIos) {
					if (uni) {
						uni.postMessage({
							data: {
								action: 'setCamera'
							}
						});
						//return;
					}
					if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosPhoto) {
						window.webkit.messageHandlers.iosPhoto.postMessage(null);
					}
				}
			}
		},
		/**
		 * 人脸识别通过后的统一处理
		 * 关键修复：使用 Events.PLAY 事件确保 UI 同步，并保留 pendingSeekTime 作为 fallback
		 */
		handleFaceSuccess() {
			const _this = this
			_this.middleFace = false
			const pos = _this.player ? (_this.player.currentTime || 0) : 0
			const targetTime = Math.max(0, pos - 2)
			_this.pendingSeekTime = targetTime
			_this.$utils.dialog.alert('验证成功，请继续学习', () => {
				if (!_this.player) return
				// 关键修复：直接设置 currentTime 并调用 play，不再等待 play 结果
				// 即使 play() reject，currentTime 也已设置，下次用户点击播放器会继续播放
				try {
					_this.player.currentTime = targetTime
					_this.player.play().then(() => {
						_this.pendingSeekTime = 0
					}).catch(() => {
						console.log('[study1] 人脸后 play 被拦截，等待用户手势')
						_this.bindOnceUserGesture()
					})
				} catch (e) {
					console.log('[study1] play 调用异常', e)
					_this.bindOnceUserGesture()
				}
			})
		},
		/**
		 * 人脸识别失败后处理
		 * 关键修复：提示用户再次进行人脸识别，不自动恢复播放
		 */
		handleFaceFail() {
			const _this = this
			_this.$utils.dialog.alert('人脸识别未通过，请重新进行人脸识别', () => {
				// 重新触发拍照流程
				if (_this.isUseJSPlayPhoto) {
					_this.handleFace()
				} else {
					_this.$refs.imgChange.click()
				}
			})
		},
		imgChange(event) {
			if (this.loadingFace) return
			let file = event.target.files[0];
			const _this = this;
			if (this.player) {
				this.player.pause();
			}
			new Compressor(file, {
				quality: 0.9,
				maxWidth: 413,
				maxHeight: 626,
				convertTypes: ['image/jpeg'],
				convertSize: 1000000,
				success(result) {
					console.log('study照片压缩成功');
					let reader = new FileReader();
					reader.readAsDataURL(result);
					reader.onload = (event) => {
						console.log('study执行receivePhotoResult');
						_this.receivePhotoResult(event.target.result)
					}
				},
				error(err) {
					console.log(err);
					_this.$utils.dialog.alert('照片压缩时出错，请重拍');
				}
			});
		},
		loadVideoListFormatRecursive(list, item) {
			for (let i = 0, len = list.length; i < len; i++) {
				if (list[i].basePkId === item.parentPkId) {
					if (!list[i].children) list[i].children = []
					list[i].children.push(item)
					if (JSON.stringify(this.orderVideoLocal) === '{}') {
						if (item.watchedFlag === '0') {
							this.orderVideoLocal = item
							this.playVideo = item
							this.playVideoChapter = this.videoTree.find(item => item.basePkId === list[i].parentPkId)
							this.orderChapterLocal = this.videoTree.find(item => item.basePkId === list[i].parentPkId)
							this.loadVideo(item)
						}
					}
					break
				} else if (list[i].children) {
					list[i].children = this.loadVideoListFormatRecursive(list[i].children, item)
				}
			}
			return list
		},
		// 点击回退
		clickNavBack() {
			const _this = this
			this.$api.checkSignOut(this.$route.query.signId).then(res => {
				if (res.code === 0) {
					if (res.data.canBeSignOut == 1) {
						Dialog.confirm({
							title: '温馨提示',
							message: '如您退出学习，请先点击签退按钮签退，否则会影响学时送审。',
							theme: 'round-button',
							confirmButtonColor: store.state.app.theme.colorMain,
							cancelButtonColor: '#D4D4D4',
							confirmButtonText: '签退',
							width: 290,
						}).then((res) => {
							if (res === 'confirm') {
								if (_this.isUseJSPlayPhoto) {
									_this.handleFace()
								} else {
									_this.$refs.imgChange.click()
								}
							}
						}).catch((err) => {
							if (err === 'cancel') {
								// _this.$router.push('/train')
							}
						})
					} else {
						_this.$router.push('/train')
					}
				}
			})
		},
		receivePhotoResult(base64) {
			const _this = this;
			this.loadingFace = true
			if (',102,104,105,106,168,'.indexOf(',' + _this.categoryId + ',') !== -1 && _this.provinceCode === '360000') {
				// 江西初学
				if (_this.middleFace) { // 如果是中间验证人脸，验证完成之后，还原为false，如果是false，就走签退
					this.destroyedTimer();
					this.$api.compareFace({
						signId: _this.$route.query.signId,
						photo: base64,
						chapterId: _this.playVideo.basePkId
					}).then((res) => {
						if (res.code === 0) {
							_this.handleFaceSuccess()
						} else {
							_this.handleFaceFail()
						}
						_this.loadingFace = false
					}).catch(() => {
						_this.loadingFace = false
						_this.handleFaceFail()
					})
				} else {
					_this.signBack({base64})
				}
			} else {
				this.$api.compareFace({
					signId: _this.$route.query.signId,
					photo: base64,
					chapterId: _this.playVideo.basePkId
				}).then((res) => {
					if (res.code === 0) {
						if (_this.middleFace) { // 如果是中间验证人脸，验证完成之后，还原为false，如果是false，就走签退
							_this.handleFaceSuccess()
						} else {
							_this.signBack({base64})
						}
					} else {
						// 人脸识别失败
						_this.handleFaceFail()
					}
					_this.loadingFace = false
				}).catch(() => {
					_this.loadingFace = false
					_this.handleFaceFail()
				})
			}
		},
		/** 签退 **/
		signBack({base64 = '', mediaId = ''}) {
			const _this = this
			this.$api.signOut(this.$route.query.signId, base64, mediaId).then((res) => {
				if (res.code === 0) {
					_this.$utils.dialog.alert('签退成功', () => {
						_this.$router.replace('/train')
					})
				}
			})
		},
		/** 签退不带照片 **/
		signBackNoPhoto() {
			const _this = this
			Dialog.confirm({
				title: '温馨提示',
				theme: 'round-button',
				message: '是否确认签退',
				cancelButtonColor: this.$store.state.app.theme.colorMain,
				confirmButtonColor: '#ee0a24',
				cancelButtonText:'确认',
				confirmButtonText:'取消',
			}).then(() => {
			}).catch(() => {
				this.$api.signOutNoPhoto(this.$route.query.signId).then((res) => {
					if (res.code === 0) {
						_this.$utils.dialog.alert('签退成功', () => {
							window.location.href = sessionStorage.getItem("loginSteam")
							window.location.reload()
						})
					}
				})
			});
		},
		signtip(index) {
			this.iscolor = index;
			if (index === 0) {
				this.showPopover = false;
			} else {
				this.showPopover = false;
				localStorage.setItem('showPopover', JSON.stringify(this.showPopover));
			}
		},
		/**
		 * 强制跳转到指定时间（循环重试直到 currentTime 稳定）
		 * 关键修复：使用最原始的 seek 方法
		 * 原因：移动端某些浏览器在 LOADED_METADATA 触发时 video.currentTime 设置可能不生效，
		 *      通过循环重试 + setTimeout 直到 currentTime 稳定在目标时间附近
		 * 关键修复：currentTime 稳定后立即调用 play()，不依赖 PLAYING 事件
		 */
		forceSeekTo(targetTime) {
			if (!this.player || !targetTime) return
			let retryCount = 0
			const maxRetries = 30
			const tolerance = 1  // 容差 1 秒
			let seekDone = false
			const trySeek = () => {
				if (!this.player) return
				const cur = this.player.currentTime || 0
				if (Math.abs(cur - targetTime) < tolerance) {
					// currentTime 已经在目标范围内，停止重试
					console.log('[study1] forceSeekTo 完成', cur, '准备播放')
					// 关键修复：currentTime 稳定后立即调用 play()
					if (!seekDone) {
						seekDone = true
						this.player.play().catch(() => {
							console.log('[study1] forceSeekTo 后 play 被拦截，等待用户手势')
							this.bindOnceUserGesture()
						})
					}
					return
				}
				if (retryCount >= maxRetries) {
					console.log('[study1] forceSeekTo 达到最大重试次数', cur)
					return
				}
				try {
					this.player.currentTime = targetTime
					console.log('[study1] forceSeekTo 重试', retryCount, '->', this.player.currentTime)
				} catch (e) {
					console.log('[study1] forceSeekTo 异常', e)
				}
				retryCount++
				setTimeout(trySeek, 200)
			}
			trySeek()
		},
		/**
		 * 监听一次性首点击/触摸，用于自动播放失败时由用户手势恢复播放
		 * 移动端浏览器自动播放策略要求：必须先有用户手势才能解除静音并播放
		 * 关键修复（移动端）：
		 *  1. touchstart 优先（移动端手势），click 作为兜底
		 *  2. 过滤来自播放器控件的事件，避免循环触发
		 *  3. play reject 时手动 emit Events.PLAY 触发 UI 同步，避免按钮消失
		 */
		bindOnceUserGesture() {
			if (this._gestureBound) return
			this._gestureBound = true
			const handler = (e) => {
				// 移动端：忽略来自播放器控件的手势（避免循环触发或重复触发）
				if (e && e.target && e.target.closest && (e.target.closest('.xgplayer') || e.target.closest('[class*="xg-"]'))) {
					return
				}
				document.removeEventListener('click', handler)
				document.removeEventListener('touchstart', handler)
				this._gestureBound = false
				if (!this.player) return
				// 用户手势后解除静音（自动播放必须是静音的）
				this.player.muted = false
				this.player.play().then(() => {
					if (this.pendingSeekTime > 0) {
						this.player.currentTime = this.pendingSeekTime
						this.pendingSeekTime = 0
					}
				}).catch((err) => {
					console.log('[study1] 用户手势后 play 仍失败', err)
					// 关键修复：手动触发 PLAY 事件，确保 xgplayer UI 同步（按钮显示）
					try {
						this.player.emit(Events.PLAY)
					} catch (e) {
						console.log('[study1] emit PLAY 异常', e)
					}
				})
			}
			// 移动端：touchstart 优先（手势更早触发），click 作为兜底
			document.addEventListener('touchstart', handler, { once: true, passive: true })
			document.addEventListener('click', handler, { once: true })
		},
	},
};
</script>
<style scoped>
.sign-wrap {
	position: absolute;
	top: 31px;
	right: 44px;
	width: 60%;
	z-index: 9999;
	/* position: relative; */
}

.sign-wrap img {
	width: 100%;
}

.sign-wrap .sign-text {
	width: 100%;
	display: flex;
	margin: -30px 0 0 0;
	font-size: 12px;
}

.sign-wrap .sign-text .text-box {
	display: flex;
	margin-left: 6px;
}

.sign-wrap .sign-text .text-box .text-btns {
	width: 10px;
	height: 10px;
	background-color: #fff;
	border-radius: 5px;
	margin: 4px 4px 0 0;
}

.sign-wrap .sign-text .text-box .btn-color {
	background-color: #ffac1b;
}

.sign-wrap .sign-text .text-box .text-text {
	border-bottom: 1px solid #000;
}
</style>
